import FileInput from "components/common/input/FileInput";
import { ContextModel } from "models";
import { CommonFileModel } from "models/CommonFileModel";
import React, { ChangeEvent } from "react";
import { FaRegFileAlt } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { hasFile } from "utils/utils";

type PROPS = {
  ctx: ContextModel;
  onSend: (message: string, files: CommonFileModel[]) => Promise<boolean>;
};

const MessageInputArea: React.FC<PROPS> = (props) => {
  const [message, setMessage] = React.useState("");

  const file = React.useRef<CommonFileModel>({
    file_name: "",
    file_data: "",
    image_url: "",
  });
  const [files, setFiles] = React.useState<CommonFileModel[]>([]);

  const onChangeMessage = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value);
  };

  return (
    <div className="border-t-2 border-t-black p-4">
      <div className="border p-2 bg-gray-100 rounded border-gray-400">
        <textarea
          placeholder="メッセージを送る"
          className="w-full"
          value={message}
          onChange={onChangeMessage}
          onKeyDown={async (event) => {
            if(event.keyCode === 13 && event.ctrlKey) {
              const ret = await props.onSend(message, files);
              if (ret) {
                setMessage("");
                setFiles([]);
              }
            }
          }}
        ></textarea>
        <div className="mt-2 flex flex-wrap gap-4">
          {files.map((file, index) => {
            return (
              <div
                key={index}
                className="relative border border-gray-400 bg-white pl-2 pr-4 py-2 flex justify-between items-center gap-4"
              >
                <div className="flex items-center gap-2">
                  <FaRegFileAlt className="text-jhk-blue text-3xl" />
                  <span>{file.file_name}</span>
                </div>
                <div
                  className="absolute top-0 right-0"
                  style={{ transform: "translate(10px, -10px)" }}
                >
                  <button
                    onClick={() => {
                      const idx = files.indexOf(file);
                      files.splice(idx, 1);
                      setFiles([...files]);
                    }}
                  >
                    <MdCancel className="text-3xl" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="mt-2 flex justify-between items-end gap-4">
        <FileInput
          data={file.current}
          onChange={(data: CommonFileModel | undefined) => {
            if (data && hasFile(data)) {
              const tmp = Object.assign({}, data);
              files.push(tmp);
              setFiles([...files]);
            }
            return true;
          }}
          disabled={files.length >= 10}
          accept=".xlsx,.xls,.docx,.doc,.txt,.pdf,.jpg,.png,.gif,.zip"
          ctx={props.ctx}
          name="添付するファイル"
          maxSize={10}
        />
        <button
          className={`${message.length === 0 && files.length === 0 ?  'secondary-disabled px-8 py-2': 'primary px-8 py-2'  } `}
          onClick={async () => {
            const ret = await props.onSend(message, files);
            if (ret) {
              setMessage("");
              setFiles([]);
            }
          }}
          disabled={message.length === 0 && files.length === 0}
        >
          送信する
        </button>
      </div>
    </div>
  );
};
export default MessageInputArea;
